<template>
  <div>
    <el-drawer title="活动数据" :visible.sync="show" size="60%" @close="close">
      <div class="padding-x-20">
        <div class="flex-start font-14 margin-bottom-10">
          <span>活动名称：</span>
          <span>{{now.name || ''}}</span>
        </div>
        <div class="flex-start font-14 margin-bottom-10">
          <span>隶属公司：</span>
          <span>{{now.merchantNames || ''}}</span>
        </div>
      </div>
      <div class="padding-y-20">
        <el-row :gutter="20">
         <!--  <el-col :span="6">
            <div class="text-center">
              <p class="margin-y-0 font-14 color-666">有效订单</p>
              <span class="font-20 font-weight margin-top-5 color-main">{{summary.shiYongYouHuiJinE || '0.00'}}</span>
            </div>
          </el-col> -->
          <el-col :span="8">
            <div class="text-center">
              <p class="margin-y-0 font-14 color-666">使用优惠数/订单总数</p>
              <span class="font-20 font-weight margin-top-5 color-main">{{summary.shiYongYouHuiCiShu || '0.00'}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="text-center">
              <p class="margin-y-0 font-14 color-666">优惠金额</p>
              <span class="font-20 font-weight margin-top-5 color-main">{{summary.shiYongYouHuiJinE || '0.00'}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="text-center">
              <p class="margin-y-0 font-14 color-666">订单金额合计</p>
              <span class="font-20 font-weight margin-top-5 color-main">{{summary.zhiFuZongJinE || '0.00'}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-card class="margin-top-10" :body-style="{padding: '0'}">
        <el-table v-loading="loading" :data="list" ref="agentTable" border highlight-current-row max-height="680">

          <el-table-column label="用户账号" width="120" prop="userPhone" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column width="180" label="使用时间" prop="useTime" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="使用线路" width="120" prop="lineName" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="优惠金额(元)" width="120" prop="youhui" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="订单金额(元)" width="120" prop="payAmount" :show-overflow-tooltip="true" align="center">

          </el-table-column>
          <el-table-column label="订单状态" width="120" prop="orderStatusStr" :show-overflow-tooltip="true" align="center">

          </el-table-column>
          <el-table-column label="使用订单号" width="230" prop="orderNo" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <el-button @click="copyOrderNo(scope.row.orderNo)" size="mini"
                type="text">{{scope.row.orderNo}}</el-button>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination :current-page.sync="pagination.page" :page-size="pagination.pageSize"
          :page-sizes="[10,20,30,50,100]" :total="pagination.total" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" background class="sameCity-pagination margin-top-10"
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </el-card>
    </el-drawer>
  </div>
  </div>
</template>

<script>
  import { getData } from '@/api'
  import { copyText } from "@/util/util"
  export default {
    name: 'detail',
    data() {
      return {
        show: false,
        list: [],
        now: {},
        summary: {},
        loading: false
      }
    },
    created() { },
    mounted() { },
    methods: {
      async copyOrderNo(orderNo) {
        await copyText(orderNo);
        this.$message({
          message: "复制成功",
          type: "success"
        })
      },
      close() {
        this.show = false
      },
      init(item) {
        this.now = item
        this.pagination.page = 1
        this.show = true
        this.getList()
      },
      handleCurrentChange(val) {
        this.pagination.page = val
        this.getList()
      },
      handleSizeChange(val) {
        this.pagination.pageSize = val
        this.getList()
      },
      async getList() {
        this.loading = true
        const { code, data } = await getData({
          size: this.pagination.pageSize,
          page: this.pagination.page,
          activityId: this.now.id
        })
        this.loading = false
        if (code === 0) {
          const { page, ...rest } = data
          this.summary = rest
          const { records = [], total, pages, current } = page || {}
          this.pagination = {
            ...this.pagination,
            total,
            page: current,
            pages
          }
          this.list = records
          return
        }
        this.list = []
      }
    }
  }
</script>
<style scoped lang="scss">
  .title {
    margin: 0 0 10px;
    font-size: 16px;
    font-weight: 700;

    &:before {
      content: '';
      width: 4px;
      height: 16px;
      display: inline-block;
      background: #1089ff;
      vertical-align: middle;
    }
  }
</style>